function initProductSwiper() {
  var productSwiper = new Swiper('.u-product-slider', {
    slidesPerView: 4,
    spaceBetween: 20,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      1200: { slidesPerView: 4 },
      992: { slidesPerView: 3 },
      768: { slidesPerView: 2 },
      250: { slidesPerView: 1 }
    }
  });
}

document.addEventListener('DOMContentLoaded', function() {
  function aggiornaData() {
    const doubleuspsElement = document.querySelector('.doubleusps');
    
    if (!doubleuspsElement) {
      console.error('Error: .doubleusps element not found');
      return;
    }
    const giorniDellaSettimana = doubleuspsElement.dataset.giorni.split(',');
    const mesi = doubleuspsElement.dataset.mesi.split(',');
    const nDays = window.nDays || 1;

    const ora = new Date();
    const futureDate = new Date(ora);
    futureDate.setDate(ora.getDate() + nDays); 

    const dataFormattata = `${giorniDellaSettimana[futureDate.getDay()]}, ${futureDate.getDate()} ${mesi[futureDate.getMonth()]}`;
    
    let cstmDate = document.getElementById('cstmdate');
    if (cstmDate) {
      cstmDate.innerText = dataFormattata;
    }

    const msFinoAllaMezzanotte = new Date(ora.setHours(24, 0, 0, 0)) - ora;
    setTimeout(() => {
      aggiornaData();
      setInterval(aggiornaData, 24 * 60 * 60 * 1000);
    }, msFinoAllaMezzanotte);
  }

  aggiornaData();
});

  (function () {
    const popupSliders = {};

    const setSlideState = (slide, active) => {
      const video = slide.querySelector('video');
      const muteBtn = slide.querySelector('.m-crcvdepop-popup-mute');
      if (!video) return;
      if (active) {
        video.muted = false;
        video.play().catch(() => {});
        if (muteBtn) muteBtn.classList.add('is-m-crcvdepop-unmuted');
      } else {
        video.pause();
        video.currentTime = 0;
        video.muted = true;
        if (muteBtn) muteBtn.classList.remove('is-m-crcvdepop-unmuted');
      }
    };

    const initMCrcvdepop = () => {
      document.querySelectorAll('.m-crcvdepop-item:not([data-m-crcvdepop-bound])').forEach((item) => {
        item.setAttribute('data-m-crcvdepop-bound', '');

        item.querySelectorAll('.m-crcvdepop-circle-video').forEach((v) => {
          const src = v.getAttribute('data-src');
          if (src) {
            v.src = src;
            v.play().catch(() => {});
          }
          v.addEventListener('playing', () => v.closest('.m-crcvdepop-circle').classList.add('is-m-crcvdepop-ready'));
        });

        new Swiper(item.querySelector('.m-crcvdepop-slider'), {
          slidesPerView: 5,
          spaceBetween: 15,
          navigation: {
            nextEl: item.querySelector('.m-crcvdepop-next'),
            prevEl: item.querySelector('.m-crcvdepop-prev'),
          },
          pagination: {
            el: item.querySelector('.m-crcvdepop-pagination'),
            clickable: true,
          },
        });
      });

      document.querySelectorAll('dialog.m-crcvdepop-dialog:not([data-m-crcvdepop-bound])').forEach((dialog) => {
        dialog.setAttribute('data-m-crcvdepop-bound', '');
        const blockId = dialog.id.replace('m-crcvdepop-dialog-', '');

        dialog.querySelectorAll('video').forEach((v) => {
          const src = v.getAttribute('data-src');
          if (src && !v.src) v.src = src;
        });

        popupSliders[blockId] = new Swiper(dialog.querySelector('.m-crcvdepop-popup-slider'), {
          effect: 'coverflow',
          grabCursor: true,
          centeredSlides: true,
          slidesPerView: 3,
          spaceBetween: 200,
          coverflowEffect: {
            rotate: 22,
            stretch: 0,
            depth: 150,
            modifier: 1,
            slideShadows: false,
          },
          navigation: {
            nextEl: dialog.querySelector('.m-crcvdepop-popup-next'),
            prevEl: dialog.querySelector('.m-crcvdepop-popup-prev'),
          },
          on: {
            slideChangeTransitionStart: function () {
              this.slides.forEach((slide, i) => setSlideState(slide, i === this.activeIndex));
            },
          },
        });

        dialog.addEventListener('close', () => {
          dialog.querySelectorAll('video').forEach((v) => {
            v.pause();
            v.currentTime = 0;
            v.muted = true;
          });
          dialog
            .querySelectorAll('.m-crcvdepop-popup-mute')
            .forEach((b) => b.classList.remove('is-m-crcvdepop-unmuted'));
        });
      });
    };

    window.mCrcvdepopOpen = function (blockId, index) {
      const dialog = document.getElementById('m-crcvdepop-dialog-' + blockId);
      const popupSlider = popupSliders[blockId];
      if (!dialog || !popupSlider) return;
      dialog.showModal();
      popupSlider.update();
      popupSlider.slideTo(index, 0);
      popupSlider.slides.forEach((slide, i) => setSlideState(slide, i === index));
    };

    window.mCrcvdepopToggleMute = function (btn, e) {
      e.stopPropagation();
      const video = btn.closest('.m-crcvdepop-popup-media').querySelector('video');
      if (!video) return;
      video.muted = !video.muted;
      btn.classList.toggle('is-m-crcvdepop-unmuted', !video.muted);
    };

    initMCrcvdepop();
    document.addEventListener('shopify:section:load', initMCrcvdepop);
  })();